/*
 * @Author: lishuai lish@zhiding.com.cn
 * @Date: 2023-01-10 17:53:03
 * @LastEditors: lishuai lish@zhiding.com.cn
 * @LastEditTime: 2024-11-06 10:08:32
 * @FilePath: \sst-sjt-online-fe\src\network\request.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import axios from "axios";
import Router from "../router/index"
import { reLoginWhenRemoveLocalToken } from "@/util/util.js";

const service = axios.create({
    // 测试环境用 VUE_APP_BASE_API , 开发环境用访问的目标域名
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(config => {
    // 对请求头做定制的修改
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // token 失效后，强制用户退出
    if (res.data.code == 40025) {
        // 移除token 
        localStorage.removeItem('token')
        // 根据当前路由，用户上次登陆项目类型，决定用户应该进入那个路由
        reLoginWhenRemoveLocalToken()
    }
    // 40044 标识当前项目是无效项目
    if (res.data.code == 40044) {
        // Router
        Router.push({
            name: 'projectNotFound'
        })
    }
    return res.data
},
    error => {
        let { message } = error
        // 对通用的错误码进行处理
        return Promise.reject(error)
    }
)

export default service
